export const setmailData = data => ({
  type: 'SET_MAIL_DATA',
  payload: { data },
});
